import { ErrorBase } from './base';

export class NotImplementedError extends ErrorBase {
	constructor(msg?: string) {
		super(`Code is not implemented yet!😔\n ${msg}`);
	}
}
